import React from "react";
import T from "prop-types";
import { usePageTitle } from "2g-hooks";
import { PageMessageError, PageMessageEmpty } from "2g-page-message";
import Loadbar from "2g-loadbar";

import { useZdroj } from "b2b/api/hooks";
import { useServerMessage } from "b2b/i18n";
import ZdrojEditaceWidget from "b2b/components/zdroj-editace-widget/ZdrojEditaceWidget";

import useMessages from "./i18n/useMessages";

export function ZdrojDetail({ id }) {
  const message = useServerMessage();
  const { titlePlaceholder, messageEmpty } = useMessages();
  const { data, loading, loaded, error } = useZdroj({ id });

  usePageTitle(
    data
      ? `${message(data, "nazev")} ( ${message(data, "popis")} )`
      : titlePlaceholder()
  );

  return (
    <>
      {loading && <Loadbar />}
      {error ? (
        <PageMessageError error={error} />
      ) : !data && loaded ? (
        <PageMessageEmpty message={messageEmpty} />
      ) : (
        <ZdrojEditaceWidget zdroj={data} loading={loading} />
      )}
    </>
  );
}

ZdrojDetail.propTypes = { id: T.number.isRequired };

export default React.memo(ZdrojDetail);
